import { Form, Col, Button, HeaderRow, Card, LoaderOverlay, VariantPicker } from "@emanprague/ppaskit";
import { Check, Input } from "@frui.ts/bootstrap";
import type { ViewComponent } from "@frui.ts/views";
import { preventDefault, registerView } from "@frui.ts/views";
import { NoticeBar } from "components/NoticeBar";
import type SimplePortalSettings from "entities/simplePortalSettings";
import { runInAction } from "mobx";
import { observer } from "mobx-react-lite";
import React from "react";
import NoticeSettingsPageViewModel from "viewModels/admin/noticeSettingsPageViewModel";

const noticeSettingsDetailView: ViewComponent<NoticeSettingsPageViewModel> = observer(({ vm }) => {
  const settings = vm.settings;

  const card = (setting: SimplePortalSettings) => {
    return (
      <Card>
        <Card.Body>
          <HeaderRow level={3} title={vm.translate(setting.key)}>
            <div style={{ display: "flex", alignItems: "baseline" }}>
              <Check
                custom
                className="mb-2"
                id={`${setting.key}-check`}
                target={setting}
                property="active"
                label={vm.translate("active")}
              />
              <Button
                variant="primary"
                onClick={() => {
                  void vm.confirmRequest(setting);
                }}
                className="ml-3">
                {vm.translateGeneral("save_button")}
              </Button>
            </div>
          </HeaderRow>
          <Form
            onSubmit={preventDefault(() => {
              void vm.confirmRequest(setting);
            })}>
            {!setting.disabled && (
              <Form.Row>
                <Form.Group as={Col} xs={12}>
                  <Form.Label className="admin-form-header">{vm.translate("preview")}: </Form.Label>
                  <NoticeBar content={setting.value} variant={setting.variant ?? "info"} translateFunc={vm.translateGeneral} />

                  <Form.Label className="mt-3">{vm.translate("value")}</Form.Label>
                  <Input {...{ as: "textarea", rows: 3 }} disabled={setting.disabled} target={setting} property="value" />

                  <div style={{ display: "flex", alignItems: "baseline", gap: "1rem", marginTop: "1rem" }}>
                    <Form.Label className="mt-3">{vm.translate("variant")}</Form.Label>
                    <VariantPicker
                      value={setting.variant ?? "info"}
                      onChange={value => {
                        runInAction(() => {
                          setting.variant = value;
                        });
                      }}
                      variantLabels={{
                        info: vm.translate("variants.info"),
                        warning: vm.translate("variants.warning"),
                        danger: vm.translate("variants.danger"),
                      }}
                    />
                  </div>
                </Form.Group>
              </Form.Row>
            )}
          </Form>
        </Card.Body>
      </Card>
    );
  };

  return (
    <>
      <HeaderRow level={1} title={vm.name} className="mx-1 mx-sm-n3" />
      <LoaderOverlay loading={vm.busyWatcher.isBusy}>{settings?.map(setting => card(setting))}</LoaderOverlay>
    </>
  );
});

registerView(noticeSettingsDetailView, NoticeSettingsPageViewModel);

export default noticeSettingsDetailView;
